import { render, staticRenderFns } from "./MyCollectionGroupItem.vue?vue&type=template&id=2954128e&"
import script from "./MyCollectionGroupItem.vue?vue&type=script&lang=js&"
export * from "./MyCollectionGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports